module.exports = __webpack_public_path__ + "img/ico_close.8204ba14.svg";